<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-17 11:02:08
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:57:12
 * @name: 审核人员通过
 * @Description: 审核人员通过
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\dialog\approve-resolve.vue
 * @Author: desktop
-->
<template>
  <addNeditDialog
    ref="addNeditDialog"
    title="审批通过"
    bar-title="基本信息"
    @close="close"
  >
    <template v-slot:form>
      <div class="row">
        <div class="label">琴行名称</div>
        <div class="value">
          <font>{{ info.agency_name }}</font>
        </div>
      </div>
      <div class="row">
        <div class="label">琴行地址</div>
        <div class="value">
          <font>{{ info.address }}</font>
        </div>
      </div>
      <div class="row">
        <div class="label">姓名</div>
        <div class="value">
          <font>{{ realname }}</font>
        </div>
      </div>
      <div class="row">
        <div class="label">电话号码</div>
        <div class="value">
          <font>{{ mobile }}</font>
        </div>
      </div>
      <div class="row">
        <div class="label">分配跟进销售</div>
        <div class="value">
          <el-select
            class="input"
            v-model="belong_user_id"
            placeholder="请选择跟进销售"
          >
            <el-option
              v-for="item of pianoCompany.salers"
              :key="item.id"
              :label="item.realname"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="label">分配跟进销售经理</div>
        <div class="value">
          <el-select
            class="input"
            v-model="belong_muser_id"
            placeholder="请选择跟进销售经理"
          >
            <el-option
              v-for="item of pianoCompany.managers"
              :key="item.id"
              :label="item.realname"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <!-- <div class="row">
        <div class="label">最高额度</div>
        <div class="value">
          <el-input
            class="input"
            v-model="credit_limit"
            placeholder="请输入最高额度"
          ></el-input>
        </div>
      </div>
      <div class="row">
        <div class="label">还款周期</div>
        <div class="value">
          <el-select
            class="input"
            v-model="credit_month"
            placeholder="请选择还款周期"
          >
            <el-option
              v-for="item of pianoCompany.cycles"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
      </div> -->
    </template>
    <template v-slot:btnGroup>
      <el-button type="primary" @click="confirm">确认</el-button>
      <el-button plain @click="cancel">取消</el-button>
    </template>
  </addNeditDialog>
</template>
<script>
import { debounceation } from "@/utils/decorator";
import addNeditDialog from "./addNeditDialog";
export default {
  components: {
    addNeditDialog,
  },
  props: {
    pianoCompany: {
      type: Object,
    },
  },
  data() {
    return {
      info: {},
      belong_user_id: "",
      belong_muser_id: "",
      // credit_limit: "",
      // credit_month: "",
    };
  },
  computed: {
    realname() {
      return this.info?.agency_user?.[0]?.realname ?? "";
    },
    mobile() {
      return this.info?.agency_user?.[0]?.mobile ?? "";
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Object} row 行数据
     */
    open(row) {
      this.info = row;
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化
     */
    close() {
      this.info = {};
      this.belong_user_id = "";
      this.belong_muser_id = "";
      // this.credit_limit = "";
      // this.credit_month = "";
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确认
     */
    @debounceation(300)
    confirm() {
      this.$emit("approveResolveHandler", {
        ...this.info,
        belong_user_id: this.belong_user_id,
        belong_muser_id: this.belong_muser_id,
        // credit_limit: this.credit_limit,
        // credit_month: this.credit_month,
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击取消
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
  },
};
</script>
<style lang="scss" scoped>
.row {
  margin-bottom: 20px;
  width: 420px;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 150px;
    text-align: left;
    flex-shrink: 0;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      content: "*";
      color: red;
    }
  }
  .value {
    flex: 1;
    font {
      font-size: $Vars-font-content-size;
    }
    .input {
      width: 100%;
    }
  }
}
.el-button {
  margin-left: 40px;
  width: $Var-button-width-normal;
  &:first-child {
    margin-left: 0;
  }
}
</style>